const CSRF_HEADER_NAME = "x-hunch-csrf";

export class AdminApiError extends Error {
  status: number;
  body: unknown;
  constructor(status: number, body: unknown) {
    super(`Admin API request failed (${status})`);
    this.status = status;
    this.body = body;
  }
}

async function request<T>(path: string, init: RequestInit = {}): Promise<T> {
  const method = (init.method ?? "GET").toUpperCase();
  const isMutating = ["POST", "PUT", "PATCH", "DELETE"].includes(method);

  const headers = new Headers(init.headers);
  if (isMutating) {
    headers.set(CSRF_HEADER_NAME, "1");
    if (init.body && !headers.has("content-type")) headers.set("content-type", "application/json");
  }

  const res = await fetch(path, { ...init, method, headers, credentials: "same-origin" });

  if (res.status === 204) return undefined as T;

  const body = await res.json().catch(() => undefined);
  if (!res.ok) throw new AdminApiError(res.status, body);
  return body as T;
}

function withBody(method: string, body: unknown): RequestInit {
  return body !== undefined ? { method, body: JSON.stringify(body) } : { method };
}

export const adminApi = {
  get: <T>(path: string) => request<T>(path),
  post: <T>(path: string, body?: unknown) => request<T>(path, withBody("POST", body)),
  put: <T>(path: string, body?: unknown) => request<T>(path, withBody("PUT", body)),
  delete: <T>(path: string) => request<T>(path, { method: "DELETE" }),
};
